import { createIcon } from "@chakra-ui/react";

export const ChevronLeft = createIcon({
  displayName: "ChevronLeft",
  viewBox: "0 0 24 24",
  d: "M6.97 10.887a1.135 1.135 0 0 0 0 1.549l6.25 6.563a1.009 1.009 0 0 0 1.475 0 1.135 1.135 0 0 0 0-1.549L9.18 11.66l5.511-5.791a1.135 1.135 0 0 0 0-1.549 1.009 1.009 0 0 0-1.474 0l-6.251 6.564.003.003z",
  defaultProps: {
    "aria-label": "A chevron pointing left"
  }
});

export default ChevronLeft;
